// src/firebase.js
// Vidvana Sphere — Firebase Configuration
// This file connects your app to the live Firebase project

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC_5MJ3xkTCx18NWshZT9LG-f1NhKxNF4Q",
  authDomain: "vidvana-sphere.firebaseapp.com",
  projectId: "vidvana-sphere",
  storageBucket: "vidvana-sphere.firebasestorage.app",
  messagingSenderId: "877696051607",
  appId: "1:877696051607:web:51768be2b8832860577cd2",
  measurementId: "G-GHBMMNCK5R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export services for use throughout the app
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");

export default app;
